import React, { Component } from 'react';
import axios from 'axios';
import MockAdapter from 'axios-mock-adapter'
import Qs from 'qs';
import lodash from 'lodash';
import { Modal, message } from 'antd';
import { api } from 'libs/config';
import { krStrTrim } from 'libs/utils';
import Authentication from '../pages/user/authentication/Authentication'
import ReactDOM from 'react-dom';

//axios实例，包含默认配置
const instance = axios.create({
  baseURL: api.base,
  withCredentials: true
});

// 生成mock实例
const mock = new MockAdapter(instance);
const mockCbList = []
const authentication = () =>{
  let authenticationDom = document.getElementById('authentication')
  if (authenticationDom) {
    ReactDOM.render(<Authentication></Authentication>,
      authenticationDom)
  }
}
//接口请求成功的回调
const success = (res, resolve, reject) => {
  if (res.data.code === 0) {
    resolve(res.data.data);
  } else if (res.data.code === 99) {
    reject(res.data.msg);
    // 未登录
    window.location.href = `/login?fr=${encodeURIComponent(window.location.href)}`;
  } else if (res.data.code === 11 || res.data.code === 12 || res.data.code === 13 || res.data.code === 14) {
    authentication()
  } else if ([4, 5, 6].includes(lodash.get(res, 'data.code'))) { 
    // 4--密码规则不符合要求 5---未修改过密码 6----密码超过90天未修改
    // 来自临时需求http://media-doc.corp.36kr.com/docs/5a7052dd07bc4b4a60c0d431/%E4%B8%B4%E6%97%B6%E9%9C%80%E6%B1%82%20%E4%BC%98%E5%8C%96SSO%E5%AF%86%E7%A0%81%E8%A7%84%E5%88%99-1677587190968/#id=ls937u&p=1_sso%E4%BF%AE%E6%94%B9%E5%AF%86%E7%A0%81
    // 关于5也这样处理是因为后端让5和6同样处理，已反映过需求只说了4、6这样处理。但是结论还是要求5、6同样处理；
    reject(lodash.get(res, 'data.msg'));
    const msg = lodash.get(res, 'data.msg', '');
    const msgArr = msg.split('\r\n');
    const spanStyle = {
      display: 'inline-block',
    }
    const titleSpanStyle = {
      ...spanStyle,
      width: '128px',
      textAlign: 'right'
    }
    Modal.error({
      title: '提示',
      width: 660,
      content: (<div>
        {
          msgArr.map((msgItem, index) => {
            let title = '';
            let content = '';
            if (msgItem.indexOf('：') > -1) {
              let __arr = msgItem.split('：');
              title = __arr[0];
              content = __arr[1].trim();
            } else {
              content = msgItem;
            }
            return (
              <p 
                style={{
                  margin: 0, 
                  lineHeight: 1.4, 
                  marginBottom: index===0 ? '20px': 0,
                  fontSize: index===0 ? '16px': '14px',
                  color: index===0 ? '#262626' : '#787878'
                }}>
                  {title ? <span style={titleSpanStyle}>{title}：</span> : null}
                  <span style={spanStyle}>{content}</span>
              </p>
            )
          })
        }
      </div>),
      okText: '关闭'
    })
  } else if (lodash.get(res, 'data.msg')) {
    reject(res.data.msg);
    message.error(res.data.msg);
  } else {
    reject('系统异常');
    message.error('系统异常');
  }
}

//接口请求错误的回调
const failure = (err, reject) => {
  message.error('请求异常');
  reject(err);
}

// mock专用，第一次发起http请求前，将还没有mock的规则放行
let isFirstCallExecuted = false
function firstCallHttp () {
    if (!isFirstCallExecuted) {
    mockCbList.forEach(({cb, open}) => {
      if (open)
        cb(mock)
    })
    mock.onAny().passThrough()
    isFirstCallExecuted = true
  }
}

export default {
  /**
   * 返回一个回调函数，当处于开发环境是，可以激活mock
   */
  setMockRule: (open, cb) => {
    if (process.env.REACT_APP_ENV === 'dev') {
      mockCbList.push({cb, open})
    }
  },
  get: (url, params = {}, config = {}) => {
    firstCallHttp()
    const values = krStrTrim(params);
    const data = {};
    for (let attr in values) {
      data[`param.${attr}`] = values[attr];
    }
    return new Promise((resolve, reject) => {
      instance
      .get(url, { params: data, ...config })
      .then(res => success(res, resolve, reject))
      .catch(err => failure(err, reject));
    });
  },
  post: (url, params = {}, config = {}) => {
    firstCallHttp()
    const values = krStrTrim(params);
    let data = {};
    for (let attr in values) {
      data[`param.${attr}`] = values[attr];
    }
    data = Qs.stringify(data);
    return new Promise((resolve, reject) => {
      instance
      .post(url, data, config)
      .then(res => success(res, resolve, reject))
      .catch(err => failure(err, reject));
    });
  },
  json: (url, params, config = {}) => {
    firstCallHttp()
    let data = {param: {}};
    if (params) {
      const values = krStrTrim(params);
      data = { param: values };
    }
    return new Promise((resolve, reject) => {
      instance
      .post(url, data, config)
      .then(res => success(res, resolve, reject))
      .catch(err => failure(err, reject));
    });
  },
  upload: (url, params = {}, config = {}) => {
    firstCallHttp()
    let data = params;
    return new Promise((resolve, reject) => {
      instance
      .post(url, data, { headers:{'Content-Type':'multipart/form-data'}, ...config })
      .then(res => success(res, resolve, reject))
      .catch(err => failure(err, reject));
    });
  }
}